module.exports = require("./bas-CM.js");